export default __webpack_public_path__ + "28905a2e709f0380d8e943e9d593b26d.svg";